import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactLoading from 'react-loading';
import { TextField, Button, Snackbar, Typography, Box, Tooltip, Alert } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { saveDefaultFeedbackMessages } from '../../../modules/reports/thunks';

const DefaultFeedbackMessages = ({ defaultFeedbackMessages, houseRef }) => {
  const dispatch = useDispatch();
  const message1Ref = useRef('');
  const message2Ref = useRef('');
  const message3Ref = useRef('');

  const isDefaultMessagesLoading = useSelector(state => state.reports.isDefaultMessagesLoading);
  const isDefaultFeedbackMessagesSuccess = useSelector(state => state.reports.isDefaultFeedbackMessagesSuccess);

  const handleSave = () => {
    const defaultFeedbacks = [
      { feedbackID: Number(message1Ref.current.id), message: message1Ref.current.value, },
      { feedbackID: Number(message2Ref.current.id), message: message2Ref.current.value },
      { feedbackID: Number(message3Ref.current.id), message: message3Ref.current.value }
    ];

    dispatch(saveDefaultFeedbackMessages(houseRef, defaultFeedbacks));
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          borderRadius: 1,
          bgcolor: '#e8f5fb',
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontWeight: 700 }}
          py={1}
          px={2}
        >
          Set Your Default Messages
          <Tooltip
            title="Save time by creating three default feedback messages. These are reusable messages for positive feedback. You can setup these messages at any time and use them after all your auctions."
            style={{ backgroundColor: 'whiteSmoke' }}
            placement="bottom"
          >
            <span className="ml-2">
              <FontAwesomeIcon className="color-blue" id="questionCircle" icon="question-circle" />
            </span>
          </Tooltip>
        </Typography>
      </Box>
      <Box width="400px" my={2}>
        <Typography variant="body2" fontWeight="bold" my={1}>
          Positive Message 1:
        </Typography>
        <TextField
          id={defaultFeedbackMessages[0]?.feedbackID.toString() || ''}
          variant="standard"
          className="textField"
          fullWidth
          inputRef={message1Ref}
          defaultValue={defaultFeedbackMessages[0]?.message}
        />
      </Box>
      <Box width="400px" my={2}>
        <Typography variant="body2" fontWeight="bold" my={1}>
          Positive Message 2:
        </Typography>
        <TextField
          id={defaultFeedbackMessages[1]?.feedbackID.toString() || ''}
          variant="standard"
          className="textField"
          fullWidth
          inputRef={message2Ref}
          defaultValue={defaultFeedbackMessages[1]?.message}
        />
      </Box>
      <Box width="400px" my={2}>
        <Typography variant="body2" fontWeight="bold">
          Positive Message 3:
        </Typography>
        <TextField
          id={defaultFeedbackMessages[2]?.feedbackID.toString() || ''}
          variant="standard"
          className="textField"
          fullWidth
          inputRef={message3Ref}
          defaultValue={defaultFeedbackMessages[2]?.message}
        />
      </Box>
      <Box mt={3}>
        <Button variant="contained" color="primary" className="px-5" onClick={handleSave} disabled={isDefaultMessagesLoading}>
          Save
          {isDefaultMessagesLoading && (
          <ReactLoading className="ml-2" type="spin" height="auto" width={15} />
          )}
        </Button>
        <Button variant="text" color="secondary" className="ml-3" onClick={() => window.location.href = '/reports/sessionResults/viewSessionResults'}>
          Exit Message Setup
        </Button>
      </Box>
      <Snackbar open={isDefaultFeedbackMessagesSuccess} autoHideDuration={3000}>
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Your messages have been saved.
        </Alert>
      </Snackbar>
    </>
  );
};

export default DefaultFeedbackMessages;
